export const BillcomToZohoBooksHealthCheckNotificationsType = {
  BILLCOM_TO_ZOHO_BOOKS_MANUAL_SYNC_COMPLETED:
    'BILLCOM_TO_ZOHO_BOOKS_MANUAL_SYNC_COMPLETED',
};

export const BillcomToZohoBooksHealthCheckNotificationsWithCriticalSeverityLevel: string[] =
  [];
